import React from 'react';
import { Tag, Tooltip } from 'antd';
import { EstadoCaso, OrigenCaso } from '../../../api/altasCasosApi';
import { ESTADO_FAMILIAS, ESTADO_LABELS, ORIGEN_LABELS } from './estado';
import { FctEstado, FctIcono } from '../../../fct/react';

export const EstadoCasoTag: React.FC<{ estado: EstadoCaso }> = ({ estado }) => (
  <FctEstado personalizado={{ etiqueta: ESTADO_LABELS[estado], ...ESTADO_FAMILIAS[estado] }} />
);

export const OrigenTag: React.FC<{ origen: OrigenCaso }> = ({ origen }) => (
  <Tag>{ORIGEN_LABELS[origen]}</Tag>
);

/**
 * Indicador de verificación de email (D22) — solo aplica a origen web con email. Icono del
 * manual en una tinta (check / cerrar, R-14) con la familia del semáforo y el texto en tooltip.
 * `verificado === null/undefined` = desconocido (la web no ha respondido o no hay registro
 * web, GESCL-T03): no se muestra nada para no afirmar un estado que no se conoce.
 */
export const EmailVerificadoBadge: React.FC<{ verificado?: boolean | null; aplica: boolean }> = ({
  verificado,
  aplica,
}) => {
  if (!aplica || verificado === null || verificado === undefined) return null;
  const titulo = verificado
    ? 'Email verificado (estado que mantiene la web)'
    : 'Email no verificado (estado que mantiene la web)';
  return (
    <Tooltip title={titulo}>
      <span
        style={{
          display: 'inline-flex',
          verticalAlign: 'middle',
          color: verificado ? 'var(--fct-exito-texto)' : 'var(--fct-riesgo-texto)',
        }}
      >
        <FctIcono nombre={verificado ? 'check' : 'cerrar'} titulo={titulo} style={{ width: 14, height: 14 }} />
      </span>
    </Tooltip>
  );
};
